{
    "Accessibility menu": "Tilgængelighedsmenu",
    "Close": "Luk",
    "Content adjustments": "Indholdsjusteringer",
    "Navigation adjustments": "Navigationsjusteringer",
    "Text Align": "Text Align",
    "Align Left": "Venstrejuster",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Juster skriftstørrelse",
    "Highlight Title": "Fremhæv titel",
    "Highlight Links": "Fremhæv links",
    "Readable Font": "Læsbar skrifttype",
    "Colour adjustments": "Farvejusteringer",
    "Dark Contrast": "Mørk kontrast",
    "Light Contrast": "Lys kontrast",
    "High Contrast": "Høj kontrast",
    "High Saturation": "Høj mætning",
    "Low Saturation": "Lav mætning",
    "Monochrome": "Monokrom",
    "Tools": "Værktøjer",
    "Reading Guide": "Læseguide",
    "Big Cursor": "Stor markør",
    "Increase Font Size": "Forøg skriftstørrelse",
    "Decrease Font Size": "Formindsk skriftstørrelse",
    "Letter Spacing": "Bogstavafstand",
    "Line Height": "Linjehøjde",
    "Font Weight": "Skrifttykkelse",
    "Dyslexia Font": "Skrifttype til ordblindhed",
    "Language": "Sprog",
    "Accessibility widget": "Åbn tilgængelighedsmenu",
    "Accessibility Profiles": "Tilgængelighedsprofiler",
    "Cognitive Disability": "Kognitiv handicap",
    "Seizure Safe": "Anfaldsikker",
    "Accessibility statement": "Tilgængelighedserklæring",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Stop animationer",
    "Animation paused": "Animation sat på pause",
    "Reset all settings": "Nulstil indstillinger",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
